import { render, staticRenderFns } from "./TheMediaTabs.vue?vue&type=template&id=ae3bb454&scoped=true"
import script from "./TheMediaTabs.vue?vue&type=script&lang=js"
export * from "./TheMediaTabs.vue?vue&type=script&lang=js"
import style0 from "./TheMediaTabs.vue?vue&type=style&index=0&id=ae3bb454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3bb454",
  null
  
)

export default component.exports